export const MODULE_KEYS = {
  DASHBOARD: 'dashboard',
  SALES: 'sales',
  RENTALS: 'rentals',
  BOOKINGS: 'bookings',
  INVENTORY: 'inventory',
  CUSTOMERS: 'customers',
  PAYMENTS: 'payments',
  MAINTENANCE: 'maintenance',
  RETURNS: 'returns',
  POS: 'pos',
  CATEGORIES: 'categories',
  EXPENSES: 'expenses',
  ANALYTICS: 'analytics',
  PRODUCTS: 'products',
  LOCATIONS: 'locations',
  INVOICES: 'invoices',
  ORDERS: 'orders',
};
